import useNamespacedLocalStorage, { setNamespacedLocalStorageKey } from 'app/hooks/useNamespacedLocalStorage';

export default function useManuallyClosed() {
  return useNamespacedLocalStorage('ostroManuallyClosed', false);
}

export function setManuallyClosed(value: boolean) {
  return setNamespacedLocalStorageKey('ostroManuallyClosed', value);
}
